import { type Rule } from "antd/lib/form"
import { i18n } from "~Shared/locales/i18n"

export const createUserCompanyProfilesRules = () => ({
    company: [{ required: true, message: i18n.t("validation:required") }] as Array<Rule>,
    team: [{ required: true, message: i18n.t("validation:required") }] as Array<Rule>,
    role: [{ required: true, message: i18n.t("validation:required") }] as Array<Rule>,
})
